import {DeliveryDto, DeliverySchedule, OrderDto} from '@hconnect/tuc-processes/orderManagement'

import {Order, OrderLineItem} from '../../../../Pages/Order/Order.types'

/**
 * Maps a Hub Order to the tuc-processes OrderDto format.
 *
 * Handles differences between the two type systems:
 * - Narrows nullable shipping address fields to required strings (defaults to '')
 * - Narrows nullable customer/org fields to required strings (defaults to '')
 * - Adapts delivery schedule tuple type (hub lacks maxLoadSize/maxLoadSpaceSize)
 * - Adapts delivery status type (hub uses string, tuc-processes uses enum)
 */
export const mapHubOrderToOrderDto = (order: Order): OrderDto => ({
  ...order,
  shippingAddress: {
    ...order.shippingAddress,
    siteNumber: order.shippingAddress.siteNumber ?? '',
    siteName: order.shippingAddress.siteName ?? '',
    street: order.shippingAddress.street ?? '',
    city: order.shippingAddress.city ?? '',
    country: order.shippingAddress.country ?? ''
  },
  customer: {
    ...order.customer,
    customerNumber: order.customer.customerNumber ?? ''
  },
  lineItems: order.lineItems as [OrderLineItem],
  schedules: order.schedules as unknown as [DeliverySchedule],
  deliveries: order.deliveries as unknown as DeliveryDto[],
  deliveryProgress: order.deliveryProgress,
  orgUnitId: order.orgUnitId ?? '',
  orgUnitCountryId: order.shippingAddress.country ?? ''
})
